<template lang="html">
  <div>
    <div class="checkout__postcode relative flex flex-col">
      <label for="postcode" class="form-label">Vind met jouw postcode een aanbieder uit de buurt</label>
      <input 
        v-model="postcode"
        type="text"
        class="relative input-basics transition transition-all"
        :class="postcodeErrorState"
        name="postcode"
        placeholder="7418ET"
        aria-label="Postcode"
      >
      <img
        v-if="postcode.length < 5"
        class="absolute bottom-[1.55rem] right-6"
        src="/wp-content/themes/teachdigital/dist/img/ic_checkout_search.svg"
        alt="Zoek naar partners op basis van jouw postcode"
      />
      <img 
        v-if="postcode.length > 5"
        class="absolute bottom-[1.55rem] right-6"
        src="/wp-content/themes/teachdigital/dist/img/ic_checkout_closesearch.svg"
        alt="Zoek opnieuw"
        @click="postcode = '', postcodeErrorState = null, formattedPartners = [], $emit('isViewingPartners', false)"
      />
    </div>

    <div :class="`checkout__postcode__results mt-12 transition transition-all fade ${formattedPartners.length > 0 ? '' : 'hidden'}`">
      <div class="checkout__results relative transition transition-all ">
        <span class="text-lg font-bold border-b border-[#dee2e6] block mt-3 pt-3 pb-1">Aanbieders in de buurt</span>
        <div @click.self="selectPartner(partner)" class="checkout__results__row relative flex flex-row py-4 items-center border-b border-[#ebebeb] hover:cursor-pointer hover:bg-white hover:-mx-4 hover:px-4 hover:transition hover:transition-all hover:after:content-['Selecteren'] hover:after:absolute hover:after:bottom-3 hover:after:right-4 hover:after:text-td-orange-100" :class="selectedPartner.ID === partner.ID ? 'active' : ''" v-for="(partner, index) in formattedPartners" :key="partner.ID">
          <div @click="selectPartner(partner)" class="checkout__results__row__checkbox bg-white w-4 h-4 border-2 border-td-orange-100 rounded-full mr-4 " :class="selectedPartner.ID === partner.ID ? 'active' : ''"> </div>
          <button type="button" class="btn btn-link checkout__results__row__name text-td-orange-100 underline px-1 py-0 my-0" @click="openModal(partner)"  data-bs-toggle="tooltip" data-bs-placement="top" :title="`Details van ${partner.acf.bedrijfsgegevens.bedrijfsnaam} bekijken`">
              {{ partner.acf.bedrijfsgegevens.bedrijfsnaam }}
          </button>
          <div @click="selectPartner(partner)" class="flex flex-row items-center text-td-dark-100 ml-3 text-sm">
            <img src="/wp-content/themes/teachdigital/dist/img/ic_checkout_route.svg" />
            <span class="text-black opacity-75 ml-1">{{ `${partner.distance.text} ` }}<span class="hidden lg:inline-block"> van je verwijderd. </span></span>
          </div>
          <div @click="selectPartner(partner)" class="flex-row items-center ml-3 text-sm hidden lg:flex">
            <img src="/wp-content/themes/teachdigital/dist/img/ic_checkout_car.svg" />
            <span class="text-black opacity-75 ml-1">{{ `Ongeveer ${partner.duration.text} rijden.` }}</span>
          </div>
        </div>
        <!-- <button class="btn btn-dark-outline d-flex flex-row align-items-center mt-4" @click="listQuantity = listQuantity + 5">
          <img src="/wp-content/themes/teachdigital/dist/img/ic_checkout_loadmore.svg" />
          <span class="ms-3">Meer aanbieders laden</span>
        </button> -->
      </div>
    </div>
  </div>
</template>

<script>
import Modal from '../components/Modal'
import gmapsInit from '../utils/googlemaps'

export default {
  name: 'Step1',
  components: {
    Modal,
  },
  props: {
    partners: {
      type: Array,
      default: () => [],
      required: true,
    },
    preSelected: {
      type: Object,
      default: () => {},
      required: false,
    },
  },
  watch: {
    postcode(value) {
      this.postcode = value;
      this.validatePostcode(value);
    },
    preSelected(value) {
      this.selectedPartner = value;
    }
  },
  data() {
    return {
      postcode: '',
      postcodeErrorState: null,
      formattedPartners: [],
      selectedPartner: {},
      modalPartner: {},
      listQuantity: 5,
      modalIsActive: false,
    }
  },
  methods: {
    validatePostcode(value) {
      if (/^[1-9][0-9]{3} ?(?!sa|sd|ss|SA|SD|SS)[A-Za-z]{2}$/.test(value)) {
        this.getPartners();
        this.postcodeErrorState = 'valid';
      } else {
        if (value.length > 0) {
          this.postcodeErrorState = 'invalid';
        } else if (value.length === 0) { 
          this.postcodeErrorState = null;
        }
        this.formattedPartners = [];
      }
    },
    closeModal($event) {
      document.body.classList.remove('overflow-hidden', 'h-screen', 'lg:overflow-visible');
    },
    openModal($event) {
      this.$emit('openModal', $event);
      document.body.classList.add('overflow-hidden', 'h-screen', 'lg:overflow-visible');
    },
    selectPartner($event) {
      if (this.selectedPartner === {}) {
        this.selectedPartner = $event;
        this.$emit('select', $event);
        this.$emit('hasSelected', true);
      } else if (!this.selectedPartner.hasOwnProperty('ID') && this.selectedPartner !== $event.ID) {
        this.$emit('select', $event);
        this.selectedPartner = $event;
        this.$emit('hasSelected', true);
      } else if (this.selectedPartner.hasOwnProperty('ID') && this.selectedPartner !== $event.ID) {
        this.$emit('select', $event);
        this.selectedPartner = $event;
        this.$emit('hasSelected', true);
      } else if (this.selectedPartner.hasOwnProperty('ID') && this.selectedPartner === $event.ID) {
        this.selectedPartner = {};
        this.$emit('select', {});
        this.$emit('hasSelected', false);
      }
    },
    async getPartners() {
      
      try {
        const google = await gmapsInit();
        const partners = this.partners;
        let origin = this.postcode;
        let destination = [];

        if (origin.length === 0) { this.$emit('isViewingPartners', false); this.formattedPartners = []; }

        if (origin.length < 6) { this.$emit('isViewingPartners', false); return }

        partners.forEach( (partner) => {
          destination.push( `${partner.acf.bedrijfsgegevens.straatnaam} ${partner.acf.bedrijfsgegevens.nummer}, ${partner.acf.bedrijfsgegevens.postcode}` );
        })

        var service = new google.maps.DistanceMatrixService();
        service.getDistanceMatrix(
          {
            origins: [origin], // postcode
            destinations: destination, // partners
            travelMode: google.maps.TravelMode.DRIVING,
            unitSystem: google.maps.UnitSystem.METRIC,
            avoidHighways: false,
            avoidTolls: false,
          }, callback);

        const vm = this;

        function callback(response, status) {
          if (response.originAddresses[0] === '') {
            vm.$emit('isViewingPartners', false);
            return vm.postcodeErrorState = 'invalid', vm.formattedPartners = [];
          }

          var formattedPartners = vm.partners.map( (item, index) => {
            return { 
              ID: item.ID,
              slug: item.slug,
              acf: item.acf,
              distance: response.rows[0].elements[index].distance, 
              duration: response.rows[0].elements[index].duration, 
            };
          });
          vm.$emit('isViewingPartners', true);

          formattedPartners.sort( (a, b) => (a.distance.value > b.distance.value) ? 1 : -1)

          vm.formattedPartners = formattedPartners
        }


      } catch (error) {
        console.error(error);
      }
    }
  },
  mounted() {
    if (this.preSelected !== {}) {
      this.selectedPartner = this.preSelected;
    }
  }
}
</script>
